/**
 * Sidebar del panel administrativo.
 *
 * Controla el menú móvil y cambia la vista actual del dashboard admin sin
 * navegar entre rutas distintas.
 */
import React, { useState } from "react";
import "./NavbarDA.scss";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom"; // Para redireccionar después del logout

const NavbarDA = ({ setView, activeView }) => {
  const { currentUser, logout } = useAuth(); // Obtenemos currentUser y logout desde el contexto
  // Estado para controlar el menú; en móvil, iniciamos oculto
  const [isOpen, setIsOpen] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth > 768 : false
  );
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenuOnMobile = () => {
    if (window.innerWidth <= 768) {
      setIsOpen(false);
    }
  };

  const goToView = (view) => {
    setView(view);
    closeMenuOnMobile();
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/admin-login");
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  const menuItems = [
    {
      view: "home",
      label: "Inicio",
      icon: "/assets/images/home_ico.png",
      alt: "Inicio Ico",
    },
    {
      view: "historiales",
      label: "Historiales clínicos",
      icon: "/assets/images/historial_ico.png",
      alt: "Historial Ico",
    },
    {
      view: "dietas",
      label: "Dietas",
      icon: "/assets/images/dietas_ico.png",
      alt: "Dietas Ico",
    },
    {
      view: "rutinas",
      label: "Rutinas",
      icon: "/assets/images/rutinas_ico.png",
      alt: "Rutinas Ico",
    },
    {
      view: "acompanamiento",
      label: "Acompañamiento",
      icon: "/assets/images/mensajes_ico.png",
      alt: "Acompañamiento Ico",
    },
    {
      view: "notificaciones",
      label: "Notificaciones",
      icon: "/assets/images/notificacion_ico.png",
      alt: "Notificaciones Ico",
    },
  ];

  return (
    <nav className={`navbar-dashboard ${isOpen ? "open" : "closed"}`}>
      <div className="navbar-dashboard-top">
        <div className="logo-dashboard">
          <img src="/assets/images/logo-color.png" alt="Mentfull Logo" />
        </div>

        <button
          type="button"
          className="burger-dashboard"
          onClick={toggleMenu}
          aria-label={isOpen ? "Cerrar menú" : "Abrir menú"}
          aria-expanded={isOpen}
        >
          <img src="/assets/images/burger_ico.png" alt="Menu Dashboard" />
        </button>
      </div>

      <div className="navbar-dashboard-main">
        <div className="user-info">
          <div className="user-avatar">
            <img src="/assets/images/perfil_ico.png" alt="User Avatar" />
          </div>
          <h2>{currentUser ? currentUser.displayName : "Usuario"}</h2>
        </div>

        <ul className="menu-dashboard">
          {menuItems.map((item) => (
            <li
              key={item.view}
              className={activeView === item.view ? "active" : ""}
            >
              <button
                type="button"
                className="menu-link-button"
                onClick={() => goToView(item.view)}
              >
                <img src={item.icon} alt={item.alt} />
                <span className="menu-text">{item.label}</span>
              </button>
            </li>
          ))}
          <li>
            <button onClick={handleLogout} className="logout-button">
              <img src="/assets/images/perfil_ico.png" alt="Logout Ico" />
              <span className="menu-text">Cerrar sesión</span>
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavbarDA;
